/** @todo should we assertEvent here? */
export function unsetUserContext() {
  return {
    user: null,
    accessToken: '',
    refreshToken: '',
    ignoreRefreshToken: false,
  };
}

export default unsetUserContext;
